/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import PatientFullForm from "components/forms/patient/PatientFullForm";
import { CoreAPI_URLs } from "constants/http.const";
import useHttp from "hooks/http.hook";
import { PatientInterface } from "@malmur-technologies/medicalsystem-shared";
import { FC, useEffect, useState } from "react";
import { FormActionType } from "types/form.enum";
import { getNewPatientDataContent } from "utils/model.utils";

/**
 * Props for EditPatientDataContent component.
 */
interface Props {
  selectedPatient?: PatientInterface;
  patientId?: string;
}

/**
 * Component for editing existing patient information.
 * Fetches patient data by ID or uses provided patient object, then displays editable form.
 * 
 * @param props - Component properties including selected patient or patient ID
 * @returns Patient edit form component
 */
const EditPatientDataContent: FC<Props> = ({ selectedPatient, patientId }) => {
  const [patient, setPatient] = useState<PatientInterface>(
    selectedPatient || getNewPatientDataContent()
  );

  const [_isLoading, _error, sendRequest] = useHttp();

  useEffect(() => {
    if (patientId) {
      sendRequest(CoreAPI_URLs.PATIENTS_GENERAL_OPERATIONS, onGetPatientHandler, "GET", undefined, [
        {
          header: "x-patient-id",
          value: patientId,
        },
      ]);
    }
  }, [patientId]);

  const onGetPatientHandler = (patient: PatientInterface) => {
    setPatient(patient);
  };

  return <PatientFullForm model={patient} action={FormActionType.MODIFY} isModal={false} />;
};

export default EditPatientDataContent;
